module.exports = "<ng4-loading-spinner> </ng4-loading-spinner>\n<router-outlet>\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main